import { atom, selector } from 'recoil';
import { isVisitorPresentSelector } from './session';
export const connectionState = atom({
    key: 'connectionState',
    default: 'offline',
});
export const socketIdState = atom({
    key: 'socketIdState',
    default: undefined,
});
/**
 * Tracks the runtime state based on localStorage, events from channels and other
 * parts of the state. This atom decides if a session needs to be
 * created, reconnected or synchornized.
 */
export const webChatStateState = atom({
    key: 'webChatStateState',
    default: "idle" /* WebChatState.Idle */,
});
export const isLoadingSelector = selector({
    key: 'isLoadingSelector',
    get: ({ get }) => {
        const webChatState = get(webChatStateState);
        return (webChatState !== "synchronized" /* WebChatState.Synchronized */ &&
            webChatState !== "error" /* WebChatState.Error */);
    },
});
export const isOnlineState = atom({
    key: 'isOnlineState',
    default: true,
});
/**
 * Selector function to determine if the web-client should initiate a reconnection with the server.
 *
 * This selector combines multiple states and conditions to determine if a reconnection is necessary.
 * It evaluates the following conditions:
 * - Whether the browser has an internet connection (`isBrowserOnline`)
 * - Whether the socket is not currently connected (`isOffline`)
 * - Whether the socket was at some point connected and has a socket ID (`hasSocketId`)
 * - Whether the visitor did something in the last 30 minutes (`isVisitorPresent`)
 *
 * If all of these conditions are met, the function returns `true` indicating that a reconnection should occur.
 * Otherwise, it returns `false`.
 *
 */
export const shouldReconnectSelector = selector({
    key: 'shouldReconnectSelector',
    get: ({ get }) => {
        const isBrowserOnline = get(isOnlineState);
        const isOffline = get(connectionState) === 'offline';
        const isVisitorPresent = get(isVisitorPresentSelector);
        return isBrowserOnline && isOffline && isVisitorPresent;
    },
});
